import React, { useState } from 'react';
import HomeTopBanner from './HomeTopBanner';
import TopOffer from './TopOffer';
import TopSelling from './TopSelling';
import { useSelector } from 'react-redux';
import Loading from './Loading';
import Popup from './Popup';

function Vapes() {

  const { vapes, isWidgetLoading } = useSelector((state) => state.page);
  const { categories, isCatLoading } = useSelector((state) => state.categories);

  if (isWidgetLoading) { 
    return <Loading />; 
  }
  if (isWidgetLoading) { 
    return <Loading />; 
  }
  // Determine which categories to use based on the page
  const pageCats = vapes.categories;

  if (!pageCats) {
    return <Loading />;
  }

  // Filter selected categories
 
  const selectedCategories = categories.filter(category =>
    pageCats.includes(category._id)
  );
 
  // Check if selected categories are found
  if (selectedCategories.length === 0) {
    return <div>No Category Found</div>;
  }

  return (
    <>
      <div className='mt-10'>
      <TopSelling title="Browse Top Vapes" page='mainCat' drinksBanner='' cigarettesBanner='' categories={selectedCategories} />
        </div> 
    </>
  );
}

export default Vapes;
